function clearPhoneNumber(phoneNumber: string): string {
  return phoneNumber.replace(/(\(|\s|-|\))/g, '');
}

export function isValidPhoneNumber(phoneNumber?: string | null): boolean {
  if (!phoneNumber) {
    return false;
  }

  /* Длина телефона без символов ()|-|пробелов */
  const LENGTH_PHONE_WITHOUT_EXCESS = 11;

  return clearPhoneNumber(phoneNumber).length === LENGTH_PHONE_WITHOUT_EXCESS;
}
